"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

export function useMetaPageView() {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window === "undefined") return;

    if (typeof window.fbq === "function") {
      window.fbq("track", "PageView");
    }

    console.log("[Meta Pixel] PageView:", pathname);
  }, [pathname]);
}
